export default __webpack_public_path__ + "static/media/goldwalls.3fec5fb0.png";